export default {
    callGetItemsCart: (state) => !state.calledGetItemsCart,
    listCartWithAdditionalProducts : (state) => {
        return state?.itemsCart?.list
            ?.filter(el => {
                el.additional_products = []
                if(el.has_childs_additionals == true) {
                    el.additional_products.push(
                        state.itemsCart.list.filter(p => p.uuid_item_father_cart == el.uuid)
                    )
                    return el
                }
            })

    },
    containsAdditionalProductsInCart : (state) => {
        return !!state?.itemsCart?.list?.find(el => el.has_childs_additionals == true)
    },
    // Tudo do carrinho que muda a cotacao de frete: itens, quantidades e o valor
    // com cupom. Quando muda, o frete escolhido deixa de valer no servidor.
    // Nulo ate o carrinho chegar do servidor: o estado inicial e [] e, sem isso,
    // a primeira carga do checkout contava como mudanca e cotava de novo.
    quoteSignature : (state) => {
        if (!Array.isArray(state?.itemsCart?.list)) {
            return null
        }
        return JSON.stringify([
            (state.itemsCart.list ?? []).map(el => [el.id, el.uuid, el.qtd_cart]),
            state.itemsCart.productsNetAmount ?? null,
        ])
    }
}
